<script lang="ts">
	import { readDeviceSettings } from 'src/stores/device-runtime/status-selectors';
	import { devices_settings } from 'src/stores/device-runtime/status';
	import { showNewLayout } from 'src/stores/toDelete/new_layout';
	//Services
	import { localReq, postReq } from '../../../../services/http';
	import { format } from '../../../../services/i18n';
	//Helpers
	import { get_local_ip } from '../../../../helpers/interface_helpers';
	//Design system components
	import { Button, ButtonV2, Input, InputV2, Text, toast } from '@Shelly/shelly-design-system';
	import type { Writable } from 'svelte/store';
	import type { SidepanelStickyBottomProps } from 'src/components/Sidepanel/sidepanel-types';
	import { getContext, onDestroy } from 'svelte';
	import SettingGuide from '../../SettingGuide.svelte';
	export let device;

	const settings = readDeviceSettings(device.id);
	let value = settings.power_correction;
	let cache = value;
	let loading = false;
	let min = 0.85;
	let max = 1.15;
	const localIp = get_local_ip(device.id);

	$: InputC = $showNewLayout ? InputV2 : Input;
	$: ButtonC = $showNewLayout ? ButtonV2 : Button;
	$: isSaveDisabled = loading || cache === value;

	const setConsCalc = async () => {
		if (cache !== value) {
			let res;
			loading = true;

			if (localIp) {
				res = await localReq(device, `${localIp}/settings/`, 'post', {
					power_correction: value,
				});
			} else {
				res = await postReq(`/device/${device.category}/settings/power_correction`, {
					power_correction: value,
					channel: device.channel,
					id: device.id,
				});
			}

			if (res.isok) {
				settings.power_correction = value;
				devices_settings.update_devices_settings(device.id, settings);
				toast.open({
					type: 'success',
					title:
						$format('consumption_correction_change_scc_toast', {
							values: { value },
							default: `Consumption correction was changed to ${value}.`,
						}) || `Consumption correction was changed to ${value}.`,
				});
				cache = value;
			} else {
				toast.open({
					type: 'danger',
					title: $format('error_global', { default: 'Something went wrong!' }),
				});
				value = cache;
			}
			loading = false;
		}
	};

	const stickyBottomAction =
		getContext<Writable<SidepanelStickyBottomProps | null>>('stickyBottomAction');

	$: if (stickyBottomAction) {
		if ($showNewLayout) {
			stickyBottomAction.set({
				onClick: setConsCalc,
				loading,
				disabled: isSaveDisabled,
				icon: 'fas fa-save',
			});
		} else {
			stickyBottomAction.set(null);
		}
	}

	onDestroy(() => {
		stickyBottomAction?.set(null);
	});
</script>

<SettingGuide
	text={$format('settings_guide_consumption_correction', {
		default:
			'Scale the reported power if the reading is systematically off. Allowed range is 0.85 to 1.15.',
	})}
/>

<Text styleType="body-small" class="mb-s">
	{$format('set_consumption_correction', {
		values: { min, max },
		default: 'Set consumption correction ({min} - {max}):',
	})}
</Text>

<svelte:component
	this={InputC}
	class="mb-s"
	size="m"
	bind:value
	type="number"
	{min}
	{max}
	step={0.01}
	on:enter={setConsCalc}
	id="input-jkubzuv"
	aria-label={$format('set_consumption_correction', {
		values: { min, max },
		default: 'Set consumption correction ({min} - {max}):',
	})}
/>

{#if !$showNewLayout}
	<svelte:component this={ButtonC} class="mt-s" {loading} size="m" width="full" on:click={setConsCalc}
		>{$format('button_save', { default: 'Save' })}</svelte:component
	>
{/if}
